import { render, staticRenderFns } from "./ExclusaoConta.vue?vue&type=template&id=7c28e816&"
import script from "./ExclusaoConta.vue?vue&type=script&lang=js&"
export * from "./ExclusaoConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports